import { useState } from 'react';
import { CreativityType } from '../../../../types/banner';

import { FormRenderer } from '../../../../constants/clients/template-config.interface';
import { getCreativityOptions } from '../../../../constants/clients/registry';
import { useClientId } from '../../../use-client-id';

export const useFormRenderer = (creativityType: CreativityType, fieldsLength: number) => {
  const clientId = useClientId();
  const creativityOptions = getCreativityOptions(clientId);
  const template = creativityOptions.find(t => t.id === creativityType);
  const defaultRenderer = template?.config?.renderer || 'default';

  const [rendererType, setRendererType] = useState<FormRenderer>(defaultRenderer);

  const shouldShowRendererSelector = fieldsLength > 5;

  const rendererOptions = [
    { value: 'default', label: 'Lista simple' },
    { value: 'accordion', label: 'Acordeón expandible' }
  ];

  return {
    rendererType,
    setRendererType,
    shouldShowRendererSelector,
    rendererOptions
  };
};
